import useQueryParams from '@core/hooks/useQueryParams';

const useEmbeddedVoyagerObersver = () => {
  const params = useQueryParams();
  const isEmbeddedVoyager = params?.embedded === 'true';

  return {
    isEmbeddedVoyager,
  };
};

export default useEmbeddedVoyagerObersver;
